/**
 * What the UI calls stock that left the shelf which inventory never received.
 *
 * One constant because the business renames it — it read "Unverified" until 2026-09. Call sites
 * case it themselves (`.toUpperCase()` for the all-caps lot tables, `.toLowerCase()` mid-sentence),
 * so a rename is this line and nothing else. The API field names are unrelated and stay as they
 * are: `unverifiedQty`, `isUnverified` and the rest are the contract, not the wording.
 */
const SYSTEM_DEFICIT = 'System Deficit';

export default SYSTEM_DEFICIT;
